import { useIsDarkTheme } from 'hooks/useIsDarkTheme';
import { useMemo } from 'react';

const DARK_COLORS = ['#E78573', '#87ADD2', '#B8D670', '#B481BB', '#EFB96C', '#FAEE7B', '#9CD2C8', '#F4D0E5'];
const LIGHT_COLORS = ['#E78573', '#87ADD2', '#B8D670', '#B481BB', '#EFB96C', '#FAEE7B', '#9CD2C8', '#F4D0E5'];

export interface BarChartHooksType {
  chartColors: Array<string>;
  strokeColor: string;
}

export const useBarChartHooks = (): BarChartHooksType => {
  const { isDarkMode } = useIsDarkTheme();

  return useMemo(
    () => ({
      chartColors: isDarkMode ? DARK_COLORS : LIGHT_COLORS,
      strokeColor: isDarkMode ? `#0f1315` : `#ffffff`,
    }),
    [isDarkMode]
  );
};
